module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marty Crump\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Marty Crump")]), _vm._v(" is currently an adjunct professor of biology at Utah State and Northern Arizona Universities. She has been a herpetologist for more than forty-five years, working with tropical amphibians in the areas of parental care, reproduction, territoriality, cannibalism, and tadpole ecology. Her work has drawn attention to the issue of declining amphibian populations. In addition to her popular science writing, she is the author of the recent award-winning children’s book, "), _c('I', [_vm._v("The Mystery of Darwin’s Frog")]), _vm._v(". She lives in Logan, UT.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/W1kzeG/tc-custom/9780226094434.jpg?1722579937324",
      "alt": "This image is the cover for the book Ain't Love Grand!, Chicago Shorts"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ain't Love Grand!, Chicago Shorts\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The natural world is filled with diverse—not to mention quirky and odd—animal behaviors. Consider the male praying mantis that continues to mate after being beheaded; the insects, insects, and birds that offer gifts of food in return for sex; the male hip-pocket frog that carries his own tadpoles; the baby spiders that dine on their mother; or the starfish that sheds an arm or two to escape a predator's grasp. In "), _c('i', [_vm._v("Ain’t Love Grand,")]), _vm._v(" Marty Crump—a tropical field biologist well known for her work with the reproductive behavior of amphibians—examines the bizarre conduct of animals as they mate, parent, feed, defend themselves, and communicate. More importantly, Crump points out that diverse and unrelated animals often share seemingly erratic behaviors—evidence, Crump argues, that these natural histories, though outwardly weird, are actually successful ways of living.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0